<template>
	<Modal
		v-if="showModal"
		:allow-close="true"
		:max-width="'max-w-[270px]'"
		@modal:close="closeModal"
	>
		<template #body>
			<div>
				<h3
					class="text-center text-[20px] leading-[24px] font-bold text-won-blue"
				>
					Margin Setup
				</h3>
               
				<div class="mx-auto mt-11 flex max-w-28 flex-col gap-3">
					<div class="grid grid-cols-2 items-center">
						<span
							class="text-left text-base font-medium text-won-dark-gray"
						>
							Top
						</span>
						<TextInput 
							v-model="marginTop"
							:margin-top="false"
							:show-errors="false"
						/>
					</div>

					<div class="grid grid-cols-2 items-center">
						<span
							class="text-left text-base font-medium text-won-dark-gray"
						>
							Bottom
						</span>
						<TextInput
							v-model="marginBottom"
							:margin-top="false"
							:show-errors="false"
						/>
					</div>

					<div class="grid grid-cols-2 items-center">
						<span
							class="text-left text-base font-medium text-won-dark-gray"
						>
							Left
						</span>
						<TextInput
							v-model="marginLeft"
							:margin-top="false"
							:show-errors="false"
						/>
					</div>

					<div class="grid grid-cols-2 items-center">
						<span
							class="text-left text-base font-medium text-won-dark-gray"
						>
							Right
						</span>
						<TextInput
							v-model="marginRight"
							:margin-top="false"
							:show-errors="false"
						/>
					</div>
				</div>
			</div>
		</template>

		<template #actions>
			<div class="flex w-full gap-3">
				<button
					class="w-full rounded border border-[#C2C4C6] py-2 text-won-dark"
					@click="closeModal"
				>
					Cancel
				</button>
    
				<button
					class="w-full rounded bg-won-green py-2 text-white hover:opacity-90 disabled:bg-won-gray"
					@click="saveMarginsHandler"
				>
					OK
				</button>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { ref, toRefs, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useBuilderStyles } from '../../store/builder-style.store';
import { useBuilder } from '../../store/builder.store';

import TextInput from '../../forms/elements/text.vue';
import Modal from '../../components/modal.vue';

const props = defineProps({
	showModal: {
		type: Boolean,
		default: false
	},
	closeModal: {
		type: Function,
		default: () => {}
	}
});

const { closeModal } = toRefs(props);

const builderStore = useBuilder();
const { data } = storeToRefs(builderStore);

const builderStylesStore = useBuilderStyles();

const marginTop = ref(36);
const marginBottom = ref(36);
const marginLeft = ref(60);
const marginRight = ref(60);

watch(data, (newVal) => {
	if (newVal == null) {
		return;
	}
    
	const {
		top_margin,
		bottom_margin,
		left_margin,
		right_margin
	} = newVal.options;
    
	marginTop.value = top_margin || 36;
	marginBottom.value = bottom_margin || 36;
	marginLeft.value = left_margin;
	marginRight.value = right_margin;
});

const saveMarginsHandler = () => {
	const margins = {
		top: marginTop.value,
		bottom: marginBottom.value,
		left: marginLeft.value,
		right: marginRight.value,
	};
    
	builderStylesStore.updateMargins(margins);

	closeModal.value();
};
</script>

